// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1AXeG","head":"ProcedureTableInfo_head__359vM"};